export default "__VITE_ASSET__PuQZ48v0__"